import { useDataLayerAction } from '../TagContext'
import { useEffect } from 'react'
import { CategoryInterface, Maybe, Products } from '@pylot-data/fwrdschema'

export const usePlpTracking = (
    category?: Maybe<CategoryInterface>,
    isValidating?: boolean,
    visibleProductData?: Maybe<Products>
): void => {
    const dataLayerAction = useDataLayerAction()
    useEffect(() => {
        if (category && !isValidating) {
            dataLayerAction({
                type: 'PLP',
                data: {
                    category,
                    products: visibleProductData
                }
            })
        }
    }, [dataLayerAction, category])
}
